import { Button } from '@/components/ui/button';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@/components/ui/modal';

interface AudioConsentModalProps {
  open: boolean;
  isSaving: boolean;
  onAccept: () => void;
  onClose: () => void;
}

const AudioConsentModal: React.FC<AudioConsentModalProps> = ({
  open,
  isSaving,
  onAccept,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      name="audio-consent"
      className="modal--glass"
    >
      <ModalHeader>
        <h2>Allow Voice Transcription</h2>
      </ModalHeader>
      <ModalBody>
        <p className="!m-0">
          Allow Ora to use your microphone audio to transcribe speech? Ora does
          not store or share your audio.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="outline"
          context="modal"
          onClick={onClose}
          disabled={isSaving}
        >
          Cancel
        </Button>
        <Button context="modal" onClick={onAccept} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Agree & Start'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AudioConsentModal;
